import * as S from "./styles";

export default function Disclaimer() {
  return (
    <S.DisclaimerText weight="regular" variant="lightGray" size="x-small">
      * O valor que você receberá pode variar de acordo com o método de pagamento e parcelamento escolhido pelo
      comprador.
    </S.DisclaimerText>
  );
}
